import {
  Accordion,
  AccordionSizeEnum,
  AccordionVariantEnum,
  Card,
  PaginatorTwoPagesIcon,
  AssignIcon,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GeneralHeader } from '@/components/HeaderPage/HeaderPage';
import { BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitAditionalInfo/components/BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable';
import { ESegmentToolkit } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/types';
import { ReportComponent } from '@/features/broadcast-schedule-program/components/ReportDrawer/components/ReportComponent';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

import { ClipAdditionalInfoDetail } from './ClipAdditionalInfoDetail';
import { getClipAssignations } from './utils';

export default function ClipAdditionalInfo() {
  const { t } = useTranslation();
  const { handleTooltikClick, activeClip } = useBroadcastScheduleProgram();
  const [accordionsOpen, setAccordionsOpen] = useState<Set<string>>(new Set(['detalle']));
  const clipAssignations = activeClip ? getClipAssignations(activeClip) : [];

  const handleToggleAccordion = (accordion: string) => {
    setAccordionsOpen(prev => {
      const newSet = new Set(prev);
      if (newSet.has(accordion)) {
        newSet.delete(accordion);
      } else {
        newSet.add(accordion);
      }
      return newSet;
    });
  };

  return (
    <Card
      classes={{
        rootSection: clsx('w-full flex-auto order-3 lg:order-2'),
        container: 'py-size-4',
      }}
    >
      <div className="flex w-full flex-col gap-2">
        <>
          <GeneralHeader
            name={t('Información')}
            onClose={() => handleTooltikClick(ESegmentToolkit.INFORMACION)}
          />
          {activeClip?.review_state === 5 && <ReportComponent item={activeClip} type="segment" />}

          <Accordion
            variant={AccordionVariantEnum.Annotation}
            title={t('Detalle')}
            icon={PaginatorTwoPagesIcon}
            isOpen={accordionsOpen.has('detalle')}
            onOpen={() => {
              handleToggleAccordion('detalle');
            }}
            size={AccordionSizeEnum.Sm}
          >
            <ClipAdditionalInfoDetail item={activeClip} />
          </Accordion>
          <Accordion
            variant={AccordionVariantEnum.Annotation}
            title={t('Asignación')}
            icon={AssignIcon}
            isOpen={accordionsOpen.has('asignacion')}
            onOpen={() => {
              handleToggleAccordion('asignacion');
            }}
            size={AccordionSizeEnum.Sm}
          >
            <BroadcastScheduleProgramBodySegmentToolkitAditionalInfoTable
              items={clipAssignations}
              showTentative
            />
          </Accordion>
        </>
      </div>
    </Card>
  );
}
